import React from 'react';
import './textarea.sass';

export const TextArea = ({label, onChange, onBlur, textError, name, id, value}) => {

    return (
        <div className='vv-text-area-container'>
            { label ? <p className='vv-text-area-container__label'>{label}</p>: null}
            <textarea id={id} name={name} className={`vv-text-area ${textError ? 'vv-text-area-error' : ''}`} onChange={onChange} onBlur={onBlur} value={value}/>
            { textError ?
                <div className='vv-text-area-container__error-message-container'>
                    <span>{textError}</span>
                </div>
                :
                null }
        </div>
    );
};